<template>
  <div class="notification">
    <div class="followUp">
      <div class="annulus_top">
        <div class="topTip">今日通话目标</div>
        <hr class="hr"/>
        <div class="progressBox">
          <span class="tip">通话数量</span>
          <span class="percentage">**%</span>
          <div id="oneProgress"><span class="progress"><el-progress type="dashboard" :percentage="percentage" :color="colors" :show-text="false" width="140" stroke-width="10"></el-progress></span></div>
          <div class="right_target">
            <div>目标:</div>
            <span style="color: #2d8cf0; font-weight: 600; font-size: 18px">200</span>
          </div>
          <div class="right_complete">
            <div>已完成:</div>
            <span style="color: #2d8cf0; font-weight: 600; font-size: 18px">101</span>
          </div>
        </div>
        <div class="progressBox">
          <span class="tip">有效通话数量</span>
          <span class="percentage">**%</span>
          <div id="twoProgress"><span class="progress"><el-progress type="dashboard" :percentage="percentage" :color="colors" :show-text="false" width="140" stroke-width="10"></el-progress></span></div>
          <div class="right_target">
            <div>目标:</div>
            <span style="color: #2d8cf0; font-weight: 600; font-size: 18px">200</span>
          </div>
          <div class="right_complete">
            <div>已完成:</div>
            <span style="color: #2d8cf0; font-weight: 600; font-size: 18px">101</span>
          </div>
        </div>
        <div class="progressBox">
          <span class="tip">有效通话时长</span>
          <span class="percentage">**%</span>
          <div id="threeProgress"><span class="progress"><el-progress type="dashboard" :percentage="percentage" :color="colors" :show-text="false" width="140" stroke-width="10"></el-progress></span></div>
          <div class="right_target">
            <div>目标:</div>
            <span style="color: #2d8cf0; font-weight: 600; font-size: 18px">200</span>
          </div>
          <div class="right_complete">
            <div>已完成:</div>
            <span style="color: #2d8cf0; font-weight: 600; font-size: 18px">101</span>
          </div>
        </div>
      </div>


    </div>
    <div class="notice">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-left: 10px">
        <el-tab-pane label="全部" name="all">
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">11111</span><span style="margin-right: 50px">{{
              this.nowDate
            }}</span>
          </div>
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">22222</span><span style="margin-right: 50px">{{
              this.nowDate
            }}</span>
          </div>
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">33333</span><span style="margin-right: 50px">{{
              this.nowDate
            }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="成单分享" name="shareInOrder">
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">22222</span><span style="margin-right: 50px">2022-1-01</span>
          </div>
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">33333</span><span style="margin-right: 50px">2022-1-01</span>
          </div>
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px">44444</span><span style="margin-right: 50px">2022-1-01</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="心得体会" name="experience">
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">44444</span><span style="margin-right: 50px">2022-1-01</span>
          </div>
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">44444</span><span style="margin-right: 50px">2022-1-01</span>
          </div>
          <div class="importantNotice_tip">
            <img :src="image" alt="" class="image">
            <span style="margin-left: 40px;">44444</span><span style="margin-right: 50px">2022-1-01</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import image from '../../../../public/svg/image.svg'

export default {
  name: "goalExperience",
  data() {
    return {
      activeName: 'all',
      image: image
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.notification {
  width: 1648px;
  height: 300px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;

  .notice {
    background-color: rgba(255, 255, 255, 0.5);
    float: left;
    width: 36%;
    height: 300px;

    .importantNotice_tip {
      position: relative;
      width: 98%;
      height: 50px;
      background-color: rgb(242, 244, 246);
      margin-bottom: 4px;
      line-height: 50px;

      .image {
        position: absolute;
        top: 10px;
        left: 6px;
        float: left;
      }
    }

    .importantNotice_tip:hover {
      background-color: #fff;
    }
  }

  .followUp {
    background-color: rgba(255, 255, 255, 0.5);
    float: left;
    width: 61%;
    height: 300px;
    margin-right: 36px;

    .annulus_top {
      position: relative;
      width: 100%;
      height: 100%;

      .progressBox {
        position: relative;
        float: left;
        width: 33.3%;
        height: 100%;
        padding-top: 50px;

        .tip {
          color: #2d8cf0;
          position: absolute;
          top: 76px;
          left: 44px;
        }

        .percentage {
          position: absolute;
          top: 174px;
          left: 102px;
          color: #2d8cf0;
          font-weight: 600;
          font-size: 18px
        }

        .right_target {
          position: absolute;
          top: 110px;
          left: 200px;
          display: inline-block;
        }

        .right_complete {
          position: absolute;
          top: 182px;
          left: 200px;
          display: inline-block;
        }

        #oneProgress {
          .progress {
            position: absolute;
            top: 110px;
            left: 44px;
          }
        }

        #twoProgress {
          .progress {
            position: absolute;
            top: 110px;
            left: 44px;
          }
        }

        #threeProgress {
          .progress {
            position: absolute;
            top: 110px;
            left: 44px;
          }
        }
      }

      .topTip {
        position: absolute;
        top: 10px;
        left: 20px;
        font-weight: 600;
      }

      .hr {
        position: absolute;
        top: 38px;
        left: 0;
        background-color: #ddd;
        height: 1px;
        width: 100%;
        border: none;
        margin-top: 4px;
        margin-bottom: 10px
      }
    }
  }
}
</style>
